// eslint-disable-next-line import/no-cycle
import { handleOrganisationRoutes } from '@/helpers/router';
import { permissionActionName, permissionSubjectName, PermissionSuffix } from '@/service/api/core/enums/permission';
import { PermissionEnum } from '@vini-wine/core-enums';
export default [
    {
        path: '/organisation/:orgUuid/offer-requests',
        name: 'offer-requests-list',
        component: () => import('@/views/organisation/offer-requests/Index.vue'),
        meta: {
            resource: permissionSubjectName(PermissionEnum.OFFER_REQUEST__VIEW, PermissionSuffix.USER_ORGANISATION),
            action: permissionActionName(PermissionEnum.OFFER_REQUEST__VIEW),
            pageTitle: 'pageTitles.requests.list',
        },
        beforeEnter: (to, from, next) => {
            handleOrganisationRoutes(to);
            next();
        },
    },
];
